import React, {Button, Component, useState } from "react";

import TextInput from '../../widgets/TextInput';
import _ from '../../utils/languages/languages';
import PageTitle from "../../components/PageTitle/PageTitle";

export default class UserProfilePage extends React.Component {

  constructor(props){
    super (props)

    this.state = {
      completeName: '',
      address: '',
    }

  }

  save (){
  }

  render () {

    return (
      <>
      <PageTitle title={_.tr("User Profile")} button={_.tr("Salva")} onClick={this.save.bind(this)}/>

      <TextInput name={_.tr('Nome completo')} value={this.state.completeName} 
            onChange={(text) => { this.setState({completeName: text})}
          } />

      <TextInput name={_.tr('Indirizzo')} value={this.state.address} 
            onChange={(text) => { this.setState({address: text})}
          } />          
      </>
    );
  }

}

